import { render, staticRenderFns } from "./resellers_todo.vue?vue&type=template&id=d2a3353a&"
import script from "./resellers_todo.vue?vue&type=script&lang=js&"
export * from "./resellers_todo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports